import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { dateAsString, dayAsString } from '../../shared/date.helper';
import { Inspection } from '../../shared/interfaces';
import { permissions } from '../../shared/permissions';
import { UserService } from '../../user/user.service';
import { InspectionService } from '../inspection.service';
import { InspectionStatus } from '../inspection.status';

@Component({
  selector: 'app-inspection-completed',
  templateUrl: './inspection-completed.component.html',
  styleUrls: ['./inspection-completed.component.scss'],
})
export class InspectionCompletedComponent implements OnInit {
  inspections: Inspection[] = null;

  page = 1;
  pageSize = 10;
  count = 0;
  search = '';
  loading = true;
  column = [
    { field: 'customerName', header: 'Customer', type: 'text', orderBy: 'customer.name' },
    { field: 'address', header: 'Location Address', type: 'text', orderBy: 'inspection.address' },
    { field: 'city', header: 'City', type: 'text', orderBy: 'inspection.city' },
    { field: 'state', header: 'State', type: 'text', orderBy: 'inspection.state' },
    { field: 'purpose', header: 'Purpose', type: 'text', orderBy: 'inspection.purpose' },
    { field: 'policyNumber', header: 'Policy No.', type: 'text', orderBy: 'policy.number' },
    { field: 'vendor.name', header: 'Vendor', type: 'text', orderBy: 'vendor.firstName' },
    { field: 'inspector.name', header: 'Inspector', type: 'text', orderBy: 'inspector.firstName' },
    { field: 'summary', header: 'Summary', type: 'tooltip', tooltip: 'summary', orderBy: null },
    { field: 'rating', header: 'Rating', type: 'tooltip', tooltip: 'ratingNote', orderBy: 'inspection.rating' },
    { field: 'flaggingScore', header: 'Score', type: 'text', orderBy: 'inspection.flaggingScore' },
    { field: 'lastSynced', header: 'Last Synced', type: 'date', orderBy: 'inspection.lastSynced' },
    { field: 'completed', header: 'Completed', type: 'date', orderBy: 'inspection.completed' },
    { field: 'accepted', header: 'Accepted', type: 'date', orderBy: 'inspection.accepted' },
    { field: 'paid', header: 'Paid', type: 'date', orderBy: 'inspection.paid' },
  ];
  url = 'inspection';
  canAdd = false;
  canReview = false;
  isVendor = false;

  loadDebounced = new Subject();

  actions = {
    list: [
      {
        label: 'Review',
        callback: (Inspection: Inspection) => async () => {
          console.log('Review', Inspection.id);
          return this.Review(Inspection.id);
        },
        show: item => () => {
          return this.canReview;
        },
      },
    ],
  };

  constructor(
    public inspectionService: InspectionService,
    public userService: UserService,
    private toastr: ToastrService,
    private router: Router,
  ) {}

  async ngOnInit() {
    // Debounce data loading
    this.loadDebounced
      .pipe(
        debounceTime(500),
        switchMap(params => this.loadDataLive(params)),
      )
      .subscribe();

    this.canReview = await this.userService.hasPermissions([permissions.INSPECTION.REVIEW]);
    this.canAdd = await this.userService.hasPermissions([permissions.INSPECTION.CREATE]);
    this.isVendor = (await this.userService.profile()).type === 'Vendor';

    if (this.isVendor) {
      this.column = this.column.filter(c => c.field !== 'vendor.name');
      this.url = 'inspection/vendor';
    }
  }
  loadData(params) {
    this.loadDebounced.next(params);
  }

  async loadDataLive(params) {
    let rows: any[];

    [rows, this.count] = await this.inspectionService.list({ ...params, ...{ status: InspectionStatus.COMPLETED } });

    this.inspections = rows.map(i => ({
      ...i,
      day: i.dueDate ? dayAsString(new Date(i.dueDate)) : '',
      summary: this.getSummary(i),
    }));

    this.loading = false;
  }

  getSummary(row) {
    return `${row.numberPoultryHouses || 0} poultry houses, ${row.numberGeneratorBuildings || 0} generator buildings,
            ${row.numberLitterSheds || 0} litter sheds and ${row.numberDwelings || 0} dwellings inspected`;
  }

  open(ev, id: number) {
    if (ev.target.tagName === 'TD') {
      this.router.navigateByUrl(`/inspection/form/${id}`);
    }
  }

  Review(id: number) {
    this.router.navigateByUrl(`/inspection/review/main/${id}`);
  }
}
